export const RECAPTCHA_SITE_KEY = String(process.env.RECAPTCHA_SITE_KEY)
export const MASTER_KEY = String(process.env.MASTER_KEY)
export const API_URL = String(process.env.API_URL)
export const WS_API_URL = String(API_URL.replace('https://', ''))
export const BUILD_TYPE = String(process.env.BUILD_TYPE)
export const FIREBASE_CONFIG = process.env.FIREBASE_CONFIG
export const USE_TRANSLATIONS = true
